.questionActions {
  margin-top: 0.75em;
  margin-bottom: 2em;
  white-space: normal;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .bottomInput {
    margin-left: 0;
    margin-right: 0;
  }
}

.scale {
  width: 3em;
  margin-top: 3em;
}

.scaleCollapsed {
  width: 3em;
}

.textContainer {
  flex-grow: 1;
  margin-bottom: 1em;

  & .value {
    text-align: right;
    font-size: 0.85em;
  }
}

.collapsed {
  display: flex;
  margin: 0.5em 0;
}

.collapsedPreview {
  flex-grow: 1;
}

.editButton {
  color: var(--blue);
  margin: 0;
  border: 0;
  background: transparent;
  font-size: 1.5em;
}

.removeButton {
  color: var(--blue);
  margin: 0 0.3em;
  border: 0;
  background: transparent;
  font-size: 1.2em;
}

.scaleStartValue {
  & label {
    margin-right: 2em;
  }

  & select {
    width: 5em;
  }
}
